"use client";

import { useEffect, useRef, useState } from "react";

export function useBottomBarVisible(active = true) {
	const [visible, setVisible] = useState(true);
	const lastScrollY = useRef(0);

	useEffect(() => {
		if (!active) {
			setVisible(true);
			return;
		}
		lastScrollY.current = window.scrollY;

		const onScroll = () => {
			const currentY = window.scrollY;
			const diff = currentY - lastScrollY.current;

			if (currentY < 80) {
				setVisible(true);
			} else if (diff > 8) {
				setVisible(false);
			} else if (diff < -8) {
				setVisible(true);
			}

			lastScrollY.current = currentY;
		};

		window.addEventListener("scroll", onScroll, { passive: true });
		return () => window.removeEventListener("scroll", onScroll);
	}, [active]);

	return visible;
}
